import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ContactUsPayload, ContactUsResponse, SubscriberPayload, SubscriberResponse } from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {
  private http = inject(HttpClient);
  private baseApiUrl = `${environment.communicationserviceApiBaseUrl}/api`;

  /**
   * Send contact message to the backend
   * @param contactUsPayload - ContactUsPayload object with form data
   * @returns Observable of the server response
   */
  sendContactMessage(contactUsPayload : ContactUsPayload): Observable<ContactUsResponse> {
    return this.http.post<ContactUsResponse>(`${this.baseApiUrl}/contact`, contactUsPayload);
  }

  /**
   * Send subscriber request to the backend
   * @param subscriberPayload - SubscriberPayload object with email data
   * @returns Observable of the server response
   */
  sendSubscriberRequest(subscriberPayload: SubscriberPayload): Observable<SubscriberResponse> {
    return this.http.post<SubscriberResponse>(`${this.baseApiUrl}/subscriber`, subscriberPayload);
  }
}
